import { SEO } from "@/components/SEO";
import { PageHero } from "@/components/PageHero";
import { CTASection } from "@/components/CTASection";
import { Reveal } from "@/components/Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "@/data/faqs";
import { SITE } from "@/config/site";

const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: FAQS.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export default function FAQ() {
  return (
    <>
      <SEO
        title="FAQ | NRI Property Management Hyderabad — NRI Property Services"
        description="Answers for NRI property owners: rent collection, tenant management, inspections, maintenance, painting, cleaning, agreements and complete property management in Hyderabad."
        path="/faq"
        jsonLd={faqJsonLd}
      />
      <PageHero
        eyebrow="Frequently Asked Questions"
        titleLines={["Straight Answers", "for NRI Property Owners"]}
        copy={`Everything owners ask us before handing over the keys. Something missing? WhatsApp us at ${SITE.whatsappDisplay}.`}
      />

      <section className="bg-ivory py-24 sm:py-32">
        <div className="container-site max-w-4xl">
          <Reveal>
            <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
              {FAQS.map((f, i) => (
                <AccordionItem key={i} value={`faq-${i}`} className="border-navy-900/10">
                  <AccordionTrigger
                    className="py-6 text-left font-display text-base font-bold tracking-tight text-navy-900 hover:text-gold-600 hover:no-underline sm:text-lg"
                    data-testid={`faq-q-${i}`}
                  >
                    <span className="mr-4 text-gold-500/70">{String(i + 1).padStart(2, "0")}</span>
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="pb-7 pl-12 text-sm leading-relaxed text-muted-foreground sm:text-base">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </section>

      <CTASection />
    </>
  );
}
